module.exports = __webpack_public_path__ + "img/more_kiosks.a7f352fc.jpg";